<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { alertService } from "../../services";
import { debounce, success_message, error_message } from "../../Helper/helper";
export default {
  components: { alertService, pagination },
  data() {
    const { orderBy, sortBy } = this.$route.query;
    return {
      items: [],
      sortBy: sortBy || "email_alerts.created_at",
      sortDesc: orderBy && orderBy != "" ? true : orderBy,
      search: "",
      searchData: debounce(() => {
        if (!this.init) {
          const { orderBy, sortBy } = this.$data;
          this.$router.replace({
            name: "alert-list",
            query: { orderBy, sortBy },
          });
        }
        this.getAlerts();
        this.init = false;
      }, 500),
      loading: true,
      paginations: {},
      limit: 1,
      fields: [
        { key: "item_name", label: "Product Name", sortable: true },
        { key: "sub_product_name", label: "Sub Product Name", sortable: false,thClass:"dis-event" },
        { key: "column_name", label: "Type", sortable: true },
        { key: "column_value", label: "Quantity", sortable: true },
        { key: "status", label: "Status", sortable: false,thClass:"dis-event" },
        { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
      ],
    };
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getAlerts();
    },

    getAlerts(page) {
      alertService
        .getAlerts({
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          page: page && page > 0 ? page : 1,
          search: this.search,
        })
        .then((response) => {
          this.loading = false;
          this.paginations = response.data.result;
          this.items = response.data.result.data;
        });
    },

    deleteAlert(id) {
      alertService
        .deleteAlert({
          id: id,
        })
        .then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.getAlerts();
          } else {
            error_message(response.data.message);
          }
        });
    },
  },

  mounted() {
    this.getAlerts();
  },
};
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">
              {{ trans.get("__JSON__.Alerts") }}
            </h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link
              :to="{ name: 'alert-add' }"
              class="btn btn-success btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get("__JSON__.Add Alert") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-10"></div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get("__JSON__.Search") }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="
                            trans.get('__JSON__.Search Placeholder')
                          "
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-12 table-main-list product-table table-responsive"
              >
                <b-table
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template v-slot:cell(column_name)="data">
                      <h5 class="font-size-14">{{ data.item.name }}</h5>
                  </template>

                  <template v-slot:cell(column_value)="data">
                      <h5 class="font-size-14">{{ data.item.value }}</h5>
                  </template>

                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.status === 0"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >
                      {{ trans.get("__JSON__.Inactive") }}
                    </div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-success font-size-12"
                    >
                      {{ trans.get("__JSON__.Active") }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    {{
                      data.item.name.charAt(0).toUpperCase() +
                      data.item.name.slice(1)
                    }}
                  </template>
                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{
                        name: 'alert-edit',
                        params: { id: base64(data.item.id) },
                      }"
                      class="btn btn-success btn-sm btn-rounded"
                      >Edit</router-link
                    >
                    <button
                      type="submit"
                      @click="deleteAlert(base64(data.item.id))"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                    >
                      {{ trans.get("__JSON__.Delete") }}
                    </button>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                    </div>
                  </template>

                  <template #empty>
                    <p class="text-center">
                      {{ trans.get("__JSON__.No Records Found") }}
                    </p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getAlerts"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>